module.exports = "pegasus/assets/themelp1/basic/107.png";